import { Http } from "../../../support";

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
  isValid: false
};

const setData = (store, data) => {
  store.setState((state) => {
    state.cuenta.historial_compra.info.data = { ...data };
  });
}

const get = async (store, id, params = {}) => {
  store.setState((state) => {
    state.cuenta.historial_compra.info.busy = true;
  });

  try {
    const response = await Http.get(`api/compras/${id}`, { params });

    store.setState((state) => {
      state.cuenta.historial_compra.info.data = response.data;
      state.cuenta.historial_compra.info.busy = false;
    });

    return response.data;
  } catch (error) {
    store.setState((state) => {
      state.cuenta.historial_compra.info.error = error.data || error;
      state.cuenta.historial_compra.info.busy = false;
    });
  }
}

const resetError = (store) => state => {
  state.cuenta.historial_compra.info.error = undefined;
};

const reset = (store) => state => {
  state.cuenta.historial_compra.info = { ...initialState };
};

const actions = {
  setData,
  get,
  reset,
  resetError
}

const HistorialCompraInfoStore = {
  state: () => initialState,
  actions
}

export default HistorialCompraInfoStore;